// eslint-disable-next-line max-classes-per-file
import { convertToBoolean } from "@/utils/common/formatHelper/booleanUtills";

import type { Deeplink, TravelPeriod } from "./getPromotionLandingInterface";
import { CouponsDetail } from "./getPromotionLandingInterface";

/* eslint-disable max-classes-per-file */
export class CouponDetail {
  id: string;

  couponAmountType: string;

  couponAmount: string;

  currency: string;

  couponCode: string;

  description: string;

  subDescription: string;

  couponId: string;

  title: string;

  conditionValue: string;

  couponProductType: string[];

  isOutOfStock: boolean;

  isRequireLogin: boolean;

  constructor(data: any) {
    const isOutOfStock = !data.isOutOfStock
      ? +data.id === 147296 || +data.id === 568
      : convertToBoolean(data.isOutOfStock);

    this.id = data.id || 0;
    this.description = data.description || "";
    this.subDescription = data.subDescription || "";
    this.couponAmountType = data.coupon_amount_type || "";
    this.couponAmount = data.coupon_amount || "";
    this.currency = data.currency || "";
    this.couponCode = data.coupon_code || "";
    this.couponId = data.coupon_id || "";
    this.title = data.title || "";
    this.conditionValue = data.condition_value || "";
    this.couponProductType = data.coupon_product_type || [];
    this.isOutOfStock = isOutOfStock;
    this.isRequireLogin = data.isRequireLogin || false;
  }
}

export interface SeoInterface {
  title: string;
  description: string;
}

export class PromotionDetail {
  id: string;

  title: string;

  description: string;

  startPrice: number;

  currency: string;

  product: string[];

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  homeImage: string;

  startDate: string;

  expireDate: string;

  isGother: string;

  status: string;

  slug: string;

  url: string;

  subtitle: string;

  ignoreUtmIds: string;

  seo: SeoInterface;

  constructor(data: any) {
    this.id = data.id || "";
    this.title = data.title || "";
    this.description = data.description || "";
    this.startPrice = data.startPrice || 0;
    this.currency = data.currency || "";
    this.product = data.product || [];
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.homeImage = data.homeImage || "";
    this.startDate = data.startDate || "";
    this.expireDate = data.expireDate || "";
    this.isGother = data.is_gother || "";
    this.status = data.status || "";
    this.slug = data.slug || "";
    this.url = data.url || "";
    this.subtitle = data.subtitle || "";
    this.ignoreUtmIds = data.ignore_utm_ids || "";
    this.seo = {
      title: data.seo.title || "",
      description: data.seo.description || "",
    };
  }
}

export class ResponsePromotionStatic {
  status: boolean;

  type: string;

  destinationType: number;

  promotions: PromotionDetail;

  coupon: CouponDetail[];

  coupons: CouponsDetail[];

  promotionTitle: string;

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  homeImage: string;

  isRequireLogin: boolean;

  deeplink: Deeplink;

  travelPeriod: TravelPeriod;

  constructor(data: any) {
    this.status = data.status || false;
    this.type = data.type || "";
    this.destinationType = data.destination_type ?? 9;
    this.promotions = new PromotionDetail(data.promotions);
    this.coupon = (data.coupon || []).map(
      (item: any) => new CouponDetail(item),
    );
    this.coupons = (data.coupons || []).map(
      (item: any) => new CouponsDetail(item),
    );
    this.promotionTitle = data.promotion_title || "";
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.homeImage = data.homeImage || "";
    this.isRequireLogin = convertToBoolean(data.isRequireLogin);
    this.deeplink = data.deeplink || {};
    this.travelPeriod = data.travelPeriod || {};
  }
}
